import { renderSingleFormLine } from "./formBuilder";
import { validateCaptcha, validateAndSubmit } from "./validation-library";
import CaptchaService from "./services/CaptchaService";

export let apiDomain;

export let apiVersion;

export let captchaDomain;

const setEloqaApiUrl = (apiEndpointVersion) => {
  const allowedSubdomains = ["release", "hotfix", "feature", "dev"];
  const currentHost = window.location.hostname.split(".");
  const currentHostIndex = currentHost[0] === "us" || currentHost[0] === "eu" ? 1 : 0;

  apiVersion = apiEndpointVersion;
  if (allowedSubdomains.indexOf(currentHost[currentHostIndex]) > -1) {
    const currentPort = window.location.port;
    const currentPortString = currentPort !== "" ? `:${currentPort}` : "";

    apiDomain = `https://${currentHost[currentHostIndex]}.api.eset.com${currentPortString}`;
  } else {
    apiDomain = "https://api.eset.com";
  }
};

export const deleteWarning = (formObject) => {
  const submitButton = formObject.form.querySelector(".btn-submit");

  if (submitButton) {
    submitButton.classList.remove("elq-btn-loading");
  }

  const existingErrorMsg = formObject.wrapper.querySelectorAll(".elq-error-msg");

  if (existingErrorMsg.length) {
    for (let i = 0; i < existingErrorMsg.length; i += 1) {
      existingErrorMsg[i].remove();
    }
  }
};

const renderErrors = (formObject, error) => {
  deleteWarning(formObject);
  const warning = document.createElement("p");

  warning.innerText = error.errorMessage;
  warning.classList.add("elq-error-msg");
  formObject.wrapper.appendChild(warning);
};
const preFillInputField = (formElement, input, value) => {
  // eslint-disable-next-line no-param-reassign
  input.value = value;
  const inputLabel = formElement.querySelector(`label[for="${input.id}"]`);

  if (inputLabel) {
    inputLabel.classList.add("visible");
  }
};
const preFillSelectField = (select, value) => {
  const option = select.querySelector(`option[value="${value}"]`);

  if (option) {
    option.selected = 1;
  }
};
const preFillGetParamters = (formElement) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  urlParams.forEach((value, key) => {
    const input = formElement.querySelector(`input[name="${key}"]`);
    const select = formElement.querySelector(`select[name="${key}"]`);

    if (input) {
      preFillInputField(formElement, input, value);
    }

    if (select) {
      preFillSelectField(select, value);
    }
  });
};
const triggerFloatingLabels = (formWrapper) => {
  const float = (label, input, initial) => {
    if (initial) {
      label.classList.add("visible");

      return;
    }

    if (input.value !== "") {
      label.classList.add("visible");
    } else {
      label.classList.remove("visible");
    }
  };
  const inputs = formWrapper.querySelectorAll('input[type="text"], textarea');

  inputs.forEach((input) => {
    const label = formWrapper.querySelector(`label[for='${input.id}']`);

    if (input.value !== "") {
      label.classList.add("visible");
    }

    input.addEventListener("keyup", () => {
      float(label, input);
    });
    input.addEventListener("focusout", () => {
      float(label, input);
    });
    input.addEventListener("focus", () => {
      float(label, input, true);
    });
  });
};
const setOptionInSelect = (selectElement, optionValue) => {
  if (!selectElement) {
    return;
  }

  const option = selectElement.querySelector(`option[value="${optionValue}"]`);

  if (option) {
    option.selected = 1;
  }
};
const prefillSelectByLocationData = (formElement, geoData) => {
  if (!geoData) {
    return;
  }

  const countrySelect = formElement.querySelector('select[name="country"]');
  const stateSelect = formElement.querySelector('select[name="state"]');

  setOptionInSelect(countrySelect, geoData.countryCode);
  setOptionInSelect(stateSelect, geoData.regionCode);
};
const getLocationData = (formElement) => {
  // if there is a country selectbox
  if (formElement.querySelector('select[name="country"]')) {
    const baseUrl = `${apiDomain}/${apiVersion}/geoip`;

    fetch(baseUrl, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((geoData) => prefillSelectByLocationData(formElement, geoData))
      .catch(() => {
        console.error("Fetching country failed");
      });
  }
};
const addTracking = (formElement) => {
  const currentCountry = formElement.querySelector("[name^='country']") || {
    value: "not-available",
  };
  const currentProduct = formElement.querySelector("[name^='product']") || {
    value: "not-available",
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "FormSubmitElq",
    FormName: formElement.getAttribute("name"),
    FormId: formElement.getAttribute("id"),
    elqCountry: currentCountry.value,
    elqProduct: currentProduct.value,
  });
};
const renderFormFromRequest = (formId, token, type, formObject) => {
  let requestUrl = `${apiDomain}/${apiVersion}/form/${formId}/${token}`;

  if (type) {
    requestUrl += `/?type=${type}`;
  }

  fetch(requestUrl, {
    credentials: "include",
  })
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response);
      }

      return response.json();
    })
    .then((formData) => {
      deleteWarning(formObject);
      removeCaptcha(formObject, true);
      formObject.form.setAttribute("name", formData.form.properties.name);
      formData.form.rows.forEach((row) => {
        renderSingleFormLine(row, formObject);
      });
      triggerFloatingLabels(formObject.wrapper);
      preFillGetParamters(formObject.form);
      getLocationData(formObject.form);
      removeLoader(formObject);
      const loader = formObject.wrapper.querySelector(".elq-form-loading");

      if (!document.body.contains(loader)) {
        const event = new Event("eset-eloqua-form-rendered");

        window.dispatchEvent(event);
      }

      formObject.form.onsubmit = (e) => {
        e.preventDefault();
        formObject.pendingSubmit = true;
        validateAndSubmit(formObject);
      };
    })
    .catch((error) => {
      if (error?.headers?.get("X-EDPS-Request-Status") === "blocked") {
        beforeRenderCaptcha(formObject);

        return;
      }

      removeLoader(formObject);
      renderErrors(formObject, {
        errorMessage: "Unable to get data from our server. Try again later, please.",
      });
      console.error("There has been a problem with your fetch operation:", error);
    });
};

export const prepareForm = (formObject, options = {}) => {
  const { formId, type, authToken } = formObject.wrapper.dataset;

  !apiDomain && setEloqaApiUrl(options.apiEndpointVersion);
  captchaDomain = captchaDomain || options.captchaDomain || "eset.com";
  addLoader(formObject);
  renderFormFromRequest(formId, authToken, type, formObject);
};

function addLoader(formObject) {
  if (formObject.wrapper.querySelector(".elq-form-loading") !== null) {
    return;
  }

  const loader = document.createElement("div");

  loader.classList.add("elq-form-loading");
  formObject.wrapper.appendChild(loader);
}

function removeLoader(formObject) {
  const loader = formObject.wrapper.querySelector(".elq-form-loading");

  if (loader !== null) {
    formObject.wrapper.removeChild(loader);
  }
}

const beforeRenderCaptcha = (formObject) => {
  async function captchaSubmitHandler() {
    if (!(await validateCaptcha(formObject))) {
      return;
    }

    formObject.wrapper.removeEventListener("captcha-submit", captchaSubmitHandler);
    removeCaptcha(formObject, true);
    prepareForm(formObject);
  }

  removeLoader(formObject);

  const captchaWrapper = document.createElement("div");

  captchaWrapper.classList.add("eset-captcha");
  formObject.form.appendChild(captchaWrapper);

  renderCaptcha(formObject, true);

  formObject.form.onsubmit = (e) => {
    e.preventDefault();
    captchaSubmitHandler();
  };

  formObject.wrapper.addEventListener("captcha-submit", captchaSubmitHandler);
};
const checkMultiplePicklist = (picklist) =>
  picklist
    .reduce((result, { value, selected }) => [...result, ...(selected ? [value] : [])], [])
    .join(", ");
const hideRelatedFormItems = () => {
  const itemsToHide = document.querySelectorAll(".elq-hide-on-submit");

  itemsToHide.forEach((item) => {
    // eslint-disable-next-line no-param-reassign
    item.style.display = "none";
  });
};
const buildOutputParameters = (formWrapper) => {
  const urlParams = [];
  const out = [];

  if (formWrapper.dataset.type) {
    urlParams.type = formWrapper.dataset.type;
  }

  if (formWrapper.dataset.formType) {
    urlParams["form-type"] = formWrapper.dataset.formType;
  }

  if (formWrapper.dataset.languageIsoCode) {
    urlParams.lang = formWrapper.dataset.languageIsoCode;
  }

  for (const key in urlParams) {
    if (key) {
      out.push(`${key}=${encodeURIComponent(urlParams[key])}`);
    }
  }

  return out;
};
/**
 * Checkboxes and multiselect sends multiple values as an array
 * Eloqua accepts multiple values of same input as string separated by comma
 * This method will adjust this values into acceptable form for Eloqua and generate FormData from array
 * @param submittedData
 * @returns {FormData}
 */
const structureData = (submittedData) => {
  const res = [];

  res.push(submittedData[0]);

  for (let i = 1; i < submittedData.length; i += 1) {
    if (submittedData[i].name === res[res.length - 1].name) {
      res[res.length - 1].value += `, ${submittedData[i].value}`;
    } else {
      res.push(submittedData[i]);
    }
  }

  const formData = new FormData();

  res.forEach((item, index) => {
    if (typeof item.value === "object") {
      formData.append(`${index}[value]`, item.value, item.value.name);
    } else {
      formData.append(`${index}[value]`, item.value);
    }

    formData.append(`${index}[name]`, item.name);
    formData.append(`${index}[id]`, item.id);
  });

  return formData;
};
const getSubmitData = (formElement) => {
  const data = [];
  const form = formElement;

  for (let i = 0; i < form.elements.length; i += 1) {
    const fieldName = form.elements[i].name;

    let fieldId = form.elements[i].id;
    let fieldValue = null;

    const fieldType = form.elements[i].type;
    const isFile = fieldType === "file";

    if (isFile && fieldId) {
      const file = document.getElementById(fieldId);

      if (file && file.files.length > 0) {
        (fieldValue = file.files[0]), file.files[0].name;
      }
    }

    if (!isFile) {
      if (fieldType === "checkbox" && form.elements[i].checked) {
        fieldValue = form.elements[i].value;
        if (form.elements[i].dataset.id) {
          fieldId = form.elements[i].dataset.id;
        }
      }

      if (fieldType === "select-multiple") {
        fieldValue = checkMultiplePicklist(Array.from(form.elements[i].options));
      }

      if (fieldType !== "checkbox" && fieldType !== "select-multiple") {
        fieldValue = form.elements[i].value;
      }

      if (fieldType === "radio") {
        if (form.elements[i].checked) {
          fieldValue = form.elements[i].value;
          if (form.elements[i].dataset.id) {
            fieldId = form.elements[i].dataset.id;
          }
        } else {
          fieldValue = null;
        }
      }
    }

    if (fieldName && fieldValue) {
      data.push({
        name: fieldName,
        value: fieldValue,
        id: fieldId,
      });
    }
  }

  return structureData(data);
};

function createCaptcha(formObject, withButton) {
  const wrapper = formObject.captcha;
  const captchaLabelText =
    formObject.wrapper.querySelector('input[name="captchaLabel"]')?.value || "Enter captcha code";
  const Captcha = `
  <img src="${CaptchaService.captchaDomain()}/api/v1/image/init?${window.captchaSessionId}" alt="eset-captcha" width="200" height="60">
  <button type="button">
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path></svg>
  </button>
  <div class="col-12 elq-field-style">
    <label class="elq-label elq-label-float" for="captcha-input">
      ${captchaLabelText} <span class="elq-required">*</span>
    </label>
    <input type="text" id="captcha-input" class="elq-item-input LV_invalid_field" name="singleLineText" aria-invalid="false">
  </div>
  `;

  wrapper.innerHTML = Captcha;
  if (withButton) {
    wrapper.classList.add("captcha-button");
    const button = '<input type="button" class="btn-submit captcha-submit" value="Submit">';

    wrapper.insertAdjacentHTML("beforeend", button);
    wrapper
      .querySelector(".captcha-submit")
      .addEventListener("click", () =>
        formObject.wrapper.dispatchEvent(new Event("captcha-submit"))
      );
  }

  wrapper.querySelector("button").addEventListener("click", () => renderCaptcha(formObject));
  const input = wrapper.querySelector("input");
  const label = wrapper.querySelector("label");
  const float = (el, input, initial) => {
    if (initial) {
      el.classList.add("visible");

      return;
    }

    if (input.value !== "") {
      el.classList.add("visible");
    } else {
      el.classList.remove("visible");
    }
  };

  input.addEventListener("keyup", () => {
    float(label, input);
    setCaptchaState(formObject, !!input.value);
  });

  input.addEventListener("focusout", () => float(label, input));
  input.addEventListener("focus", () => float(label, input, true));

  Object.defineProperty(formObject, "captchaImage", {
    get() {
      return this.captcha.querySelector("img");
    },
    configurable: true,
  });

  Object.defineProperty(formObject, "captchaInput", {
    get() {
      return this.captcha.querySelector("input");
    },
    configurable: true,
  });

  formObject.form.querySelector(".btn-submit").classList.remove("elq-btn-loading");
}

export function renderCaptcha(formObject, withButton) {
  const image = formObject.captchaImage;

  if (!image) {
    createCaptcha(formObject, withButton);

    return;
  }

  updateFormsCaptchaImage();

  const input = formObject.captchaInput;

  input.value = "";
  input.dispatchEvent(new Event("keyup"));
  input.focus();

  formObject.form.querySelector(".btn-submit").classList.remove("elq-btn-loading");
}

export function updateFormsCaptchaImage() {
  window.captchaSessionId = new Date().getTime();
  const forms = document.querySelectorAll("[data-form-id]");

  forms.forEach((form) => {
    const captchaImage = form.querySelector("div.eset-captcha")?.querySelector("img");

    if (captchaImage) {
      captchaImage.src = `${CaptchaService.captchaDomain()}/api/v1/image?${window.captchaSessionId}`;
    }
  });
}

export function removeCaptcha(formObject, withWrapper) {
  if (!withWrapper && formObject.captcha.innerHTML) {
    formObject.captcha.innerHTML = "";

    return;
  }

  const captcha = formObject.form.querySelector(".eset-captcha");

  if (captcha !== null) {
    formObject.form.removeChild(captcha);
  }
}

export function setCaptchaState(formObject, valid) {
  const input = formObject.captchaInput;

  if (!input) {
    return;
  }

  if (input.classList.contains(valid ? "LV_valid_field" : "LV_invalid_field")) {
    return;
  }

  input.classList.add(valid ? "LV_valid_field" : "LV_invalid_field");
  input.classList.remove(valid ? "LV_invalid_field" : "LV_valid_field");
}

function parseResponseHeaders(headers) {
  const headersArray = headers.trim().split(/[\r\n]+/);
  const headerMap = {};

  headersArray.forEach((line) => {
    const parts = line.split(": ");
    const header = parts.shift();
    const value = parts.join(": ");

    headerMap[header] = value;
  });

  return headerMap;
}

function fetchXHR(url, opts = {}, onProgress) {
  return new Promise((res, rej) => {
    const xhr = new XMLHttpRequest();

    xhr.open(opts.method || "get", url);
    xhr.withCredentials = true;
    xhr.onload = (e) => res(e.target);
    xhr.onerror = (e) => res(e.target);
    if (xhr.upload && onProgress) {
      xhr.upload.onprogress = onProgress;
    }

    xhr.send(opts.body);
  });
}

export const submitForm = (formObject) => {
  const { formId } = formObject.wrapper.dataset;
  const urlParams = buildOutputParameters(formObject.wrapper);
  const submitUrl = `${apiDomain}/${apiVersion}/form/${formId}?${urlParams.join("&")}`;
  const submitData = getSubmitData(formObject.form);
  const fileInput = formObject.wrapper.querySelector("input[type=file]");

  if (fileInput) {
    let progressBar = formObject.wrapper.querySelector("progress");

    if (!progressBar) {
      progressBar = document.createElement("progress");
      progressBar.id = "progress-bar";
      progressBar.value = "0";
      progressBar.max = "100";
      formObject.wrapper.querySelector("input[type=submit]").parentNode.appendChild(progressBar);
    }
  }

  fetchXHR(
    submitUrl,
    {
      method: "POST",
      body: submitData,
    },
    (event) => {
      const progressBar = document.getElementById("progress-bar");

      if (!progressBar) {
        return;
      }

      progressBar.value = Math.round((event.loaded / event.total) * 100);
    }
  )
    .then((response) => {
      const responseHeaders = parseResponseHeaders(response.getAllResponseHeaders());

      if (
        response?.responseHeaders?.["X-EDPS-Request-Status"] === "blocked" ||
        responseHeaders?.["x-edps-request-status"] === "blocked"
      ) {
        renderCaptcha(formObject);

        return;
      }

      if (!response) {
        renderErrors(formObject, {
          errorMessage: "Unknown server error. Try again later, please.",
        });

        return;
      }

      switch (response.status) {
        case 200: {
          addTracking(formObject.form);
          formObject.form.parentElement.removeChild(formObject.form);
          hideRelatedFormItems();
          const thankYouMsg = formObject.wrapper.querySelector(".thankyou-container");

          if (thankYouMsg !== null) {
            thankYouMsg.style.display = "block";
            thankYouMsg.scrollIntoView(false);
          }

          break;
        }

        case 429: {
          const responseErrorMessage =
            formObject.form.querySelector('input[name="contactSalesMessage"]')?.value ||
            "It appears that you have made too many requests. If you'd like to make additional requests, please try again later, or contact us to discuss your needs.";

          renderErrors(formObject, { errorMessage: responseErrorMessage });

          break;
        }

        case 413: {
          renderErrors(formObject, {
            errorMessage: "The attached file exceeded the maximum upload size (10MB)",
          });

          break;
        }

        default: {
          let errorMessage = "Unknown server error. Try again later, please.";

          if (JSON.parse(response?.response).hasOwnProperty("errorMessage")) {
            errorMessage = JSON.parse(response.response).errorMessage;
          }

          renderErrors(formObject, {
            errorMessage,
          });

          break;
        }
      }
    })
    .catch(() => {
      renderErrors(formObject, { errorMessage: "Unknown server error. Try again later, please." });
    });
};
